import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorPropFormat'
})
export class ColorPropFormatPipe implements PipeTransform {

    // transform(decoration: any, prop: string): string {
    transform({ props }, prop: string): string {
        let propAlpha;
        if (prop === 'mainColor' || prop === 'color') {
            propAlpha = 'alpha';
        } else if (/Color$/.test(prop)) {
            propAlpha = prop.substr(0, prop.length - 5) + 'Alpha';
        }

        if (!props[propAlpha] || props[propAlpha].readonly) {
            return 'hex';
        }

        return 'rgba';
    }

}
